<template>
    <div class="becomeAgency-wrapper">
        <div class="becomeAgency-innerSection position-relative" :style="{ backgroundImage: `url(${agnecyCenterBg})` }">
            <div class="congratulationsImage-box">
                <img :src='CongratulationsImage' alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import agnecyCenterBg from "../../assets/images/agency-centre/become_agency_BG.webp";
import CongratulationsImage from "../../assets/images/agency-centre/Congratulations_image.webp";
export default {
    name: "CongratulationsScreen",
    data() {
        return {
            agnecyCenterBg,
            CongratulationsImage
        }
    }
}
</script>

<style scoped>
    .congratulationsImage-box {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-90%);
    }
</style>
